import { Clear } from '@material-ui/icons'
import { DatePicker } from '@material-ui/pickers'
import { Checkbox, Shakeable } from './'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
    makeStyles,
    FormControl,
    MenuItem,
    OutlinedInput,
    Select
} from '@material-ui/core'
import { getSelectedOperationModes } from '../../../reports/utils'

const useStyles = makeStyles(theme => ({
    pickerWrapper: {
        marginTop: 15
    },
    fromDate: {
        marginRight: 16
    },
    input: {
        fontSize: 14,
        height: '32px',
        width: 150,
        borderRadius: '4px'
    },
    inputLabel: {
        transform: 'translate(14px, 9px) scale(1)'
    },
    filters: {
        display: 'flex'
    },
    clearIcon: {
        marginRight: -8,
        color: theme.secondary,
        cursor: 'pointer'
    },
    filterSelect: {
        marginRight: 16
    },
    statusFilterItem: {
        fontSize: 14
    },
    placeholderFilter: {
        color: theme.palette.text.secondary
    }
}))

const defaultStatusOptions = locale => [
    {
        label: locale.reports.info,
        key: 'info'
    },
    {
        label: locale.reports.warning,
        key: 'warning'
    },
    {
        label: locale.reports.critical,
        key: 'critical'
    },
    {
        label: locale.reports.infested,
        key: 'infested'
    },
    {
        label: locale.reports.reportTypes[20],
        key: 'catch'
    }
]

export function ReportsFilters({
    filters,
    onChange,
    className,
    fromShakeableRef
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    const statusOptions = defaultStatusOptions(locale)

    const [deviceTypeStatus, setDeviceTypeStatus] = useState(
        getSelectedOperationModes(filters)
    )
    // const [filterStatus, setfilterStatus] = useState([])
    const handleChangeOperationMode = event => {
        const {
            target: { value }
        } = event

        const mappedValue = value
            .map(i => {
                const [device_type, operation_mode] = i.split(':')
                return {
                    device_type,
                    operation_mode
                }
            })
            .reduce(
                (acc, { device_type, operation_mode }) => {
                    if (!acc.operation_modes.includes(operation_mode)) {
                        acc.operation_modes.push(operation_mode)
                    }

                    const deviceTypes =
                        device_type === 'jerry'
                            ? ['jerry', 'jerry-lora', 'jerry-bait-rat']
                            : [device_type]

                    deviceTypes.forEach(deviceType => {
                        if (!acc.device_types.includes(deviceType)) {
                            acc.device_types.push(deviceType)
                        }
                    })

                    return acc
                },
                {
                    operation_modes: [],
                    device_types: []
                }
            )

        onChange({ type: 'operationMode', value: mappedValue })

        setDeviceTypeStatus(
            // On autofill we get a the stringified value.
            typeof value === 'string' ? value.split(',') : value
        )
    }
    const handleChangeStatus = event => {
        const {
            target: { value }
        } = event

        onChange({ type: 'status', value })
        /* TODO: check if setFilterStatus is relevant */
        // setfilterStatus(
        //     // On autofill we get a the stringified value.
        //     typeof value === "string" ? value.split(",") : value
        // );
    }

    const handleClear = type => e => {
        e.stopPropagation()
        onChange({ type, date: null })
    }

    return (
        <div className={`${classes.filters} ${className}`}>
            <FormControl className={classes.filterSelect}>
                <Select
                    multiple
                    displayEmpty
                    placeholder="deviceType"
                    value={deviceTypeStatus}
                    onChange={handleChangeOperationMode}
                    MenuProps={{
                        variant: 'menu'
                    }}
                    input={
                        <OutlinedInput
                            placeholder="deviceType"
                            classes={{ root: classes.input }}
                        />
                    }
                    renderValue={selected => {
                        if (selected.length === 0) {
                            return (
                                <span className={classes.placeholderFilter}>
                                    {locale.devices.deviceOperationMode}
                                </span>
                            )
                        }

                        const selectedToShow =
                            selected.length > 3
                                ? selected.slice(0, 2)
                                : selected

                        return selectedToShow
                            .map(
                                i =>
                                    locale.devices.operationMode[
                                        i.split(':')[1]
                                    ]
                            )
                            .join(', ')
                    }}>
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes.jerry}</span>
                    </MenuItem>
                    <MenuItem value="jerry:snaptrap">
                        <Checkbox
                            checked={
                                deviceTypeStatus.indexOf('jerry:snaptrap') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                    <MenuItem value="jerry:bait">
                        <Checkbox
                            checked={
                                deviceTypeStatus.indexOf('jerry:bait') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.bait}
                        </span>
                    </MenuItem>
                    <MenuItem disabled value="">
                        <span>{locale.devices.deviceTypes.tom}</span>
                    </MenuItem>
                    <MenuItem value="tom:insect">
                        <Checkbox
                            checked={
                                deviceTypeStatus.indexOf('tom:insect') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.insect}
                        </span>
                    </MenuItem>
                    <MenuItem value="tom:movement">
                        <Checkbox
                            checked={
                                deviceTypeStatus.indexOf('tom:movement') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.movement}
                        </span>
                    </MenuItem>
                    <MenuItem value="tom:snaptrap">
                        <Checkbox
                            checked={
                                deviceTypeStatus.indexOf('tom:snaptrap') > -1
                            }
                        />
                        <span className={classes.statusFilterItem}>
                            {locale.devices.operationMode.snaptrap}
                        </span>
                    </MenuItem>
                    {/* {filterCheckboxes.map(({ label, key }) => (
                        <MenuItem
                            key={key}
                            value={key}
                        >
                            <Checkbox checked={filterStatus.indexOf(key) > -1} />
                            <span className={classes.statusFilterItem}>{label}</span>
                        </MenuItem>
                    ))} */}
                </Select>
            </FormControl>
            <FormControl className={classes.filterSelect}>
                <Select
                    multiple
                    displayEmpty
                    placeholder={locale.devices.status}
                    value={filters.statuses}
                    onChange={handleChangeStatus}
                    MenuProps={{
                        variant: 'menu'
                    }}
                    input={
                        <OutlinedInput
                            placeholder={locale.devices.status}
                            classes={{ root: classes.input }}
                        />
                    }
                    renderValue={selected => {
                        if (selected.length === 0) {
                            return (
                                <span className={classes.placeholderFilter}>
                                    Status
                                </span>
                            )
                        }
                        const selectedSliced =
                            selected.length > 3
                                ? selected.slice(0, 2)
                                : selected

                        return selectedSliced
                            .map(i => locale.reports[i])
                            .join(', ')
                    }}>
                    <MenuItem disabled value="">
                        <span>{locale.devices.status}</span>
                    </MenuItem>
                    {statusOptions.map(({ label, key }) => (
                        <MenuItem key={key} value={key}>
                            <Checkbox
                                checked={filters.statuses.indexOf(key) > -1}
                            />
                            <span className={classes.statusFilterItem}>
                                {label}
                            </span>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {/* {statusOptions.map(({ label, key }) => (
                <Checkbox
                    key={label}
                    label={label}
                    onClick={(e, v) => onChange({ type: key, checked: v })}
                    checked={filters.statuses.includes(key)}
                />
            ))} */}
            <Shakeable ref={fromShakeableRef}>
                <DatePicker
                    className={classes.fromDate}
                    disableToolbar
                    autoOk
                    disableFuture
                    InputProps={{
                        classes: {
                            root: classes.input
                        }
                    }}
                    InputLabelProps={{
                        classes: {
                            root: classes.inputLabel
                        }
                    }}
                    inputVariant="outlined"
                    variant="inline"
                    // placeholder={locale.reports.filterFrom}
                    label={locale.reports.filterFrom}
                    format="DD/MM/YYYY"
                    value={filters.from * 1000 || null}
                    onChange={value =>
                        onChange({ type: 'from', date: value.unix() })
                    }
                />
            </Shakeable>
            <DatePicker
                disableToolbar
                autoOk
                disableFuture
                InputProps={{
                    endAdornment: filters.to && (
                        <Clear
                            onClick={handleClear('to')}
                            className={classes.clearIcon}
                        />
                    ),
                    classes: {
                        root: classes.input
                    }
                }}
                InputLabelProps={{
                    classes: {
                        root: classes.inputLabel
                    }
                }}
                minDate={filters.from * 1000}
                variant="inline"
                inputVariant="outlined"
                // placeholder={locale.reports.filterTo}
                label={locale.reports.filterTo}
                format="DD/MM/YYYY"
                value={filters.to * 1000 || null}
                onChange={value => onChange({ type: 'to', date: value.unix() })}
            />
        </div>
    )
}
